import { render, staticRenderFns } from "./GerenciaCadastroHorarios.vue?vue&type=template&id=ec5d9eac"
import script from "./GerenciaCadastroHorarios.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroHorarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports